/**
 * CSS Custom Properties
 *
 * These properties can be overridden using the component's tag as selector.
 *
 * @prop --calcite-select-font-size: The font size of items in the component.
 * @prop --calcite-select-spacing: The padding around the selected option text.
 */

:host {
  @extend %component-spacing;
  @apply flex flex-col;
}

.wrapper {
  @apply relative flex items-stretch;
  inline-size: var(--select-width);
}

@include disabled();

:host([scale="s"]) {
  --calcite-select-font-size: theme("fontSize.n2h");
  --calcite-select-spacing-inline: theme("spacing.2") theme("spacing.8");

  .wrapper {
    @apply h-6;
  }

  .icon-container {
    @apply px-2;
  }
}

:host([scale="m"]) {
  --calcite-select-font-size: theme("fontSize.n1h");
  --calcite-select-spacing-inline: theme("spacing.3") theme("spacing.10");

  .wrapper {
    @apply h-8;
  }

  .icon-container {
    @apply px-3;
  }
}

:host([scale="l"]) {
  --calcite-select-font-size: theme("fontSize.0h");
  --calcite-select-spacing-inline: theme("spacing.4") theme("spacing.12");

  .wrapper {
    block-size: 44px;
  }

  .icon-container {
    @apply px-4;
  }
}

:host([width="auto"]) {
  @apply w-auto;
}

:host([width="half"]) {
  @apply w-1/2;
}

:host([width="full"]) {
  @apply w-full;
}

.select {
  @apply bg-foreground-1 border-color-input text-color-2 font-inherit focus-base m-0 box-border w-full cursor-pointer appearance-none truncate rounded-none border border-solid;
  font-size: var(--calcite-select-font-size);
  padding-inline: var(--calcite-select-spacing-inline);
  border-inline-end-width: theme("borderWidth.0");

  &:focus {
    @apply focus-inset;
  }

  &:hover {
    @apply bg-foreground-2;
  }
}

// override user agent stylesheet disabled styling
select:disabled {
  @apply border-color-input bg-opacity-100;
}

.icon-container {
  @apply border-color-input text-color-2 pointer-events-none absolute inset-y-0 flex items-center border-0 border-solid bg-transparent;
  inset-inline-end: theme("inset.0");
  border-inline-width: theme("borderWidth.0") theme("borderWidth.DEFAULT");
}

:host([status="invalid"]) {
  select,
  .icon-container {
    @apply border-color-danger;
  }

  select:focus,
  .icon-container:focus {
    @apply focus-inset-danger;
  }
}

.select:focus ~ .icon-container {
  @apply border-color-transparent;
}

@include form-validation-message();
@include hidden-form-input();
@include base-component();
